(function() {
	'use strict';

	angular.module('manageUser').config(config);

	function config($stateProvider) {
		$stateProvider.state('manageUser', {
			sticky : true,
			url : '/manage-user',
			views : {
				'manageUserView' : {
					templateUrl : 'manage-user/views/manage-user.tpl.html',
					controller : 'ManageUserCtrl',
					controllerAs : 'manageUser'
				}
			}
		});
	}
}());
